import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import pengajuanLemburService from "../../services/pengajuanLemburService";
import Cookies from "js-cookie";

export const initialState = {
    loading_pengajuan_lembur: false,
    data_pengajuan_lembur: [],
    showMessage:false,
    message:'',
}


export const getDataPengajuanLembur = createAsyncThunk('pengajuan_lembur/data',async (data, { rejectWithValue }) => {
    try {
        const response = await pengajuanLemburService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const pengajuanLemburSlice = createSlice({
    name: 'pengajuan_lembur',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_pengajuan_lembur = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPengajuanLembur.fulfilled, (state, action) => {
                state.loading_pengajuan_lembur = false
                state.data_pengajuan_lembur = action.payload??[]
            })
            .addCase(getDataPengajuanLembur.pending, (state) => {
                state.loading_pengajuan_lembur = true
            })
            .addCase(getDataPengajuanLembur.rejected, (state, action) => {
                state.loading_pengajuan_lembur = false
                state.data_pengajuan_lembur = action.payload
            })
    },
})

export const {
    showLoading,
} = pengajuanLemburSlice.actions

export default pengajuanLemburSlice.reducer
